module.exports = __webpack_public_path__ + "static/media/avatar.a78a3acb.svg";